export default {
	'no-debt-visits-to-show': 'لا يوجد زيارات دين لعرضها',
	'filter-customers': 'العملاء',
	'filter-status': 'الحالة',
	'payment-status': {
		unpaid: 'غير مدفوع',
		'partially-paid': 'مدفوع جزئياً',
		paid: 'مدفوع',
	},
}
